const onBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = '';
}

export default {
    start: () => window.addEventListener('beforeunload', onBeforeUnload),
    stop: () => window.removeEventListener('beforeunload', onBeforeUnload),
}